import { useQuery } from '@tanstack/react-query';

import { rotationsInfoKeys } from '@/hooks/tie-breaker/rotationsInfoKeys';
import { getRotationsInfo } from '@/infrastructure/network/data/tiebreaker/tie-breaker';

export const useRotationsInfoQuery = (matchId: string) => {
	return useQuery({
		queryKey: rotationsInfoKeys.rotationsInfo(matchId),
		queryFn: () => getRotationsInfo({ matchUuid: matchId }),
		enabled: !!matchId
	});
};
